import styled from 'styled-components';
import { Button } from '@/ui';
import { DEVICES, pickThemeFontStyles } from '@/theme';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 35rem;
  padding: 2rem;
`;

export const FormColumn = styled.div`
  flex-direction: column;
  gap: 0.5rem;
  display: flex;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('18', '24', 'BOLD')};
  display: flex;
  align-items: center;
  gap: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('24', '30', 'BOLD')};
  }
`;

export const StyledButton = styled(Button)`
  &&& {
    width: 100%;
    margin-bottom: 1rem;
    ${pickThemeFontStyles('14', '18', 'BOLD')};
  }
`;
